import React from "react";
import { createBaseBlock } from "./BaseBlock";
import { Typography, Tag } from "antd";
import { Tags } from "../components/Tags";

// Tag Block Recipe
const tagRecipe = {
  id: "tags-block",
  name: "Tag Block",
  globalKey: [],
  prefix: `["string from 'theme_from_title'. Use actual terms from PRs or issues or other sources— prefer real nouns like 'billing', 'migration', 'review flow'."]`,
  format: {
    type: "json",
    fields: [],
    constraints: [],
  },
  validationRules: [
    {
      type: "json_structure",
      condition: (data: any): boolean => {
        try {
          const parsed = JSON.parse(data);
          return (
            Array.isArray(parsed) &&
            parsed.every((item) => typeof item === "string")
          );
        } catch {
          return false;
        }
      },
      message: "Response must be valid JSON array of strings",
    },
  ],
};

// Tag Block Parser
function tagParser(data: any) {
  try {
    return {
      data: data[tagBlock.id],
    };
  } catch (error) {
    return {
      error: true,
      message: `Failed to parse tag data: ${
        error instanceof Error ? error.message : String(error)
      }`,
      rawContent: data,
    };
  }
}

// Tag Block Variants
const tagVariants = [
  {
    id: "default",
    name: "Default",
    description: "Standard tag display with full styling",
  },
  {
    id: "hidden",
    name: "Hidden",
    description: "Do not display the tag block. Just want it for the recipe",
  },
];

// Tag Block Renderer
function TagBlockRenderer(props: any) {
  const { data, variant, className, style } = props;

  if (data === undefined || variant === "hidden") {
    return null;
  }

  const tagsData = data[tagBlock.id];
  if (!tagsData || tagsData.length === 0) return null;

  const renderDefaultTags = (tags: string[]) => (
    <div style={{ width: "100%" }}>
      <Tags tags={tags} />
    </div>
  );
  const getTagRenderer = () => {
    return renderDefaultTags;
  };
  const renderTags = getTagRenderer();

  return (
    <div className="vzbl-panel-container">
      <Typography.Title level={4} className="vzbl-header-4">
        Tags
      </Typography.Title>
      {renderTags(tagsData)}
    </div>
  );
}

// Create Tag Block
const tagBlock = createBaseBlock({
  id: "tag",
  name: "Tag Block",
  description: "Displays tags from PRs and issues",
  recipe: tagRecipe,
  variants: tagVariants,
  parser: tagParser,
  renderer: TagBlockRenderer,
});

// Export the block for direct use
export { tagBlock };
